import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66f62c6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading" }
const _hoisted_2 = { class: "processed" }
const _hoisted_3 = { class: "shopping-cart" }
const _hoisted_4 = { class: "shopping-cart-header" }
const _hoisted_5 = { class: "shopping-cart-title" }
const _hoisted_6 = { class: "shopping-cart-title-text" }
const _hoisted_7 = { class: "shopping-cart-header-content" }
const _hoisted_8 = { class: "shopping-cart-total" }
const _hoisted_9 = { class: "price" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "EUR", -1))
const _hoisted_11 = { class: "shopping-cart-content" }
const _hoisted_12 = { class: "shopping-cart-items" }
const _hoisted_13 = { class: "shopping-cart-item-image" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "shopping-cart-item-content" }
const _hoisted_16 = { class: "shopping-cart-item-title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shopping-cart-item-platform-type" }, "PC / Key", -1))
const _hoisted_18 = { class: "shopping-cart-item-amount" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "amount" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "price-wrapper" }
const _hoisted_23 = { class: "on-this-flight" }
const _hoisted_24 = { class: "price" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "EUR", -1))
const _hoisted_26 = { class: "total-wrapper" }
const _hoisted_27 = { class: "prefix" }
const _hoisted_28 = { class: "amount" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "EUR", -1))
const _hoisted_30 = { class: "email-wrapper" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "shop-overlay",
          style: _normalizeStyle(_ctx.cssProps)
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fa', 'spinner'],
              style: {"color":"white"},
              size: "3x"
            }),
            _createElementVNode("p", null, _toDisplayString(_ctx.t("shop.processing")), 1)
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.processed)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "shop-overlay",
          style: _normalizeStyle(_ctx.cssProps)
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fa', 'check-circle'],
              style: {"color":"green"},
              size: "3x"
            }),
            _createElementVNode("p", null, _toDisplayString(_ctx.t("shop.processed")), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.processed = false))
            }, "OK")
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.shopOverlay && _ctx.$route.name != 'PrivacyPolicy' && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "shop-overlay",
          style: _normalizeStyle(_ctx.cssProps)
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fa', 'shopping-cart'],
                  size: "lg",
                  class: "icon"
                }),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t("shop.shopping-cart")), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.shoppingCart.price.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })), 1),
                  _hoisted_10
                ]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeOverlay()))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fa', 'times'],
                    size: "lg",
                    class: "icon"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shoppingCart.items, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.item.id,
                    class: "shopping-cart-item"
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: item.item.image
                      }, null, 8, _hoisted_14)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(item.item.title), 1),
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.subtractItemAmount(item.item))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fa', 'minus'],
                            size: "1x",
                            class: "white"
                          })
                        ], 8, _hoisted_19),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(item.amount), 1),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.addItemAmount(item.item))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fa', 'plus'],
                            size: "1x",
                            class: "white"
                          })
                        ], 8, _hoisted_21)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.t("shop.on-this-flight")), 1),
                        _createElementVNode("div", _hoisted_24, [
                          _createTextVNode(_toDisplayString(item.item.price.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })) + " ", 1),
                          _hoisted_25
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.t("shop.total")), 1),
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.shoppingCart.price.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1),
                _hoisted_29
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("p", null, [
                  _createVNode(_component_i18n_t, {
                    keypath: "shop.agreement",
                    style: {"white-space":"pre-line"}
                  }, {
                    privacy: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openPrivacyPolicy())),
                        class: "privacy-policy"
                      }, _toDisplayString(_ctx.t("shop.privacy-policy")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
                  placeholder: _ctx.t('shop.your-email'),
                  class: "email",
                  type: "text"
                }, null, 8, _hoisted_31), [
                  [_vModelText, _ctx.email]
                ]),
                _createElementVNode("button", {
                  disabled: !_ctx.emailValid,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendPurchaseRequest()))
                }, _toDisplayString(_ctx.t("shop.send-purchase-request")), 9, _hoisted_32)
              ])
            ])
          ])
        ], 4))
      : _createCommentVNode("", true)
  ], 64))
}